import { useState } from "react";
import { FormControl, InputAdornment } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { useAppDispatch } from "../../../../../store/hooks";
import { changingParaphrasedText, removeParaphrasedText } from "../../../../../store/qas/qasSlice";
import useTranslate from "../../../../../hooks/useTranslate";
import { colorRed } from "../../../../../constants/colors";
import CustomTextField from "@/components/MUI/CustomTextField/CustomTextField";
import { IParaphraseOptionProps } from "./ParaphraseOption.props";
import styles from "./ParaphraseOption.module.scss";

const ParaphraseOption = ({ text, idx, textArray }: IParaphraseOptionProps): JSX.Element => {
	const [inputText, setInputText] = useState<string>(text); // перефразированный текст

	const dispatch = useAppDispatch();

	const translate = useTranslate(); // hook для перевода текста

	return (
		<div className={styles.phraseBlock}>
			<FormControl fullWidth margin="dense">
				<CustomTextField
					variant="outlined"
					value={inputText}
					onChange={(e) => setInputText(e.target.value)}
					onBlur={(e) => e.target.value !== text && dispatch(changingParaphrasedText({ text: e.target.value, idx }))}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								{textArray.length > 1 && (
									<div className={styles.deletePhraseButton}>
										<FontAwesomeIcon
											icon={faTrashCan}
											color={colorRed}
											size="sm"
											onClick={() => dispatch(removeParaphrasedText(idx))}
											title={translate("button_deletePhrase")}
											style={{ cursor: "pointer" }}
										/>
									</div>
								)}
							</InputAdornment>
						),
					}}
				/>
			</FormControl>
		</div>
	);
};

export default ParaphraseOption;
